var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"container-full header"},[_vm._t("left",function(){return [_c('nav-bar-left')]}),_vm._t("right",function(){return [_c('nav-bar-user',{style:(_vm.rightShow)})]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }